export type SubmitPayload = {
  checkIn?: Date;
  checkOut?: Date;
  guests?: string;
};

export const formatDateForUrl = (date: Date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

export const buildSearchQuery = ({
  checkIn,
  checkOut,
  guests,
}: SubmitPayload) => {
  const params = new URLSearchParams();
  if (checkIn) params.set('checkin', formatDateForUrl(checkIn));
  if (checkOut) params.set('checkout', formatDateForUrl(checkOut));
  if (guests && guests.trim()) params.set('guests', guests.trim());
  return params.toString();
};
